import { message } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import styles from "../../../constants/styles.json";
import SyncIcon from "../../../assets/images/syncIcon.svg";
import discount from "../../../assets/images/discount.svg";
import information from "../../../assets/images/information.svg";
import ReturnIcon from "../../../assets/images/return.svg";
import giftVoucher from "../../../assets/images/giftVoucher.svg";
import user_add from "../../../assets/images/user_add.svg";
import POSIcon from "../../../components/PointOfSale/Retail/SvgComponent/POS";
import db from "../../../database";
import { getPricingRules } from "../../../utils/pricingRulesCache";
import messages from "../../../errors/messages.en-IN.json";
import useSessionStore from "../../../stores/useSessionStore";

const IconMenu = ({
  themeJSON,
  posConfig,
  tillAccessData,
  cart,
  isOnline,
  selectedProductInCart,
  pricePrecision,
  manualDiscountForm,
  setManualDiscountInput,
  setSelectedManualDiscountTypeValue,
  setManualDiscountModalVisible,
  setProductSearchInput,
  setAddToBagFlag,
  setOpenSalesRep,
  setIsEstimatesFlag,
  openDisplayParkedBillModal,
  handleKeyvalue,
  errorMessage,
  setReturnFlag,
  setIsPurchaseReturn,
}) => {
  return (
    <div
      style={{
        width: "18%",
        paddingTop: "2%",
        paddingBottom: "1.5%",
        display: "flex",
        flexDirection: "column-reverse",
      }}
    >
      <div
        style={{
          width: "100%",
          marginBottom: "0.01rem",
          display: tillAccessData?.productSync === "Y" ? "block" : "none",
        }}
      >
        <button
          className="cartMenuItems"
          id="sm-product-sync"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
          onClick={() => {
            let parkedBills = useSessionStore.getState().parkedList;
            if (cart.items.length > 0) {
              openDisplayParkedBillModal();
            } else if (parkedBills?.length > 0) {
              message.error(`${messages.errors.sync.clear_parked_bills}`);
            } else {
              if (isOnline) {
                handleKeyvalue("4");
              } else {
                errorMessage(`${messages.errors.sync.sync_failed}`, `${messages.errors.sync.network_error}`);
              }
            }
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              fontSize: "1vw",
            }}
          >
            <img src={SyncIcon} style={{ height: "2.5vh" }} color={"#fff"} />
            <span style={styles.screenStyles.mainScreen.posIcon}>Product Sync</span>
          </div>
        </button>
      </div>
      <div style={{ width: "100%", marginBottom: "0.37rem", display: tillAccessData?.manualDiscount === "Y" ? "block" : "none" }}>
        <button
          className="cartMenuItems"
          id="sm-discount"
          style={{ backgroundColor: "#2F3856", border: "1px solid #2F3856", borderRadius: "7px", height: "9.5vh" }}
          onClick={async () => {
            if (selectedProductInCart) {
              const pr = getPricingRules();
              const index = pr.findIndex((md) => md.mPricingrulesId === selectedProductInCart?.mPricingruleId && md.manualDiscount === "Y");
              if (index !== -1) {
                const pricingRule = pr[index];
                if (pricingRule.type !== "TD") {
                  let discountValue =
                    pricingRule.discountType === "V"
                      ? selectedProductInCart.discount
                      : ((selectedProductInCart.discount / (selectedProductInCart?.realPrice * selectedProductInCart?.weight)) * 100).toFixed(pricePrecision);
                  manualDiscountForm.setFieldsValue({ discountName: pricingRule.mPricingrulesId, discountValue: discountValue });
                  setManualDiscountInput(discountValue);
                  setSelectedManualDiscountTypeValue(pricingRule);
                } else {
                  const matchedPricingRule = cart?.manualDiscountData?.totalLevelDiscount?.findIndex((item) => item.pricingRule === pricingRule.mPricingrulesId);
                  manualDiscountForm.setFieldsValue({
                    discountName: pricingRule.mPricingrulesId,
                    discountValue: cart?.manualDiscountData?.totalLevelDiscount[matchedPricingRule]?.discountValue,
                  });
                  setManualDiscountInput(cart?.manualDiscountData?.totalLevelDiscount[matchedPricingRule]?.discountValue);
                  setSelectedManualDiscountTypeValue(pricingRule);
                }
              } else {
                manualDiscountForm.resetFields();
                setManualDiscountInput("");
                setSelectedManualDiscountTypeValue("");
              }
            }
            cart.items.length > 0 && setManualDiscountModalVisible(true);
            setProductSearchInput("");
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
            <img src={discount} style={{ height: "2.6vh" }} color={"#fff"} />
            <span className="posIcon" style={{ color: "#fff", fontSize: "0.8vw" }}>
              Manual Discount
            </span>
          </div>
        </button>
      </div>
      <div style={{ width: "100%", display: "none" }}>
        <button
          className="cartMenuItems"
          id="sm-pos"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <POSIcon color={"#fff"} />
            <span className="posIcon" style={{ color: "#fff", fontSize: "0.8vw" }}>
              Point of Sale
            </span>
          </div>
        </button>
      </div>
      <div style={{ width: "100%", marginBottom: "0.37rem", display: "none", fontSize: "1vw" }}>
        <button
          className="cartMenuItems"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
            <img src={information} style={{ height: "2.7vh" }} color={"#fff"} />
            <span className="posIcon" style={{ color: "#fff", fontSize: "0.8vw" }}>
              Information
            </span>
          </div>
        </button>
      </div>
      <div style={{ width: "100%", marginBottom: "0.37rem", display: "none", fontSize: "1vw" }}>
        <button
          className="cartMenuItems"
          id="sm-return"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
          onClick={() => {
            if (cart.items.length > 0) {
              openDisplayParkedBillModal();
            } else {
              handleKeyvalue("3");
              setReturnFlag(true);
              setIsPurchaseReturn(true);
            }
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
            <img src={ReturnIcon} style={{ height: "2.5vh" }} color={"#fff"} />
            <span className="posIcon" style={{ color: "#fff", fontSize: "0.8vw" }}>
              Return
            </span>
          </div>
        </button>
      </div>
      <div
        style={{
          width: "100%",
          marginBottom: "0.37rem",
          display: posConfig?.showBags === "Y" ? "block" : "none",
        }}
      >
        <button
          className="cartMenuItems"
          id="sm-discount"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
          onClick={() => {
            setAddToBagFlag(true);
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
            <img src={giftVoucher} style={{ height: "2.6vh" }} color={"#fff"} />
            <span style={styles.screenStyles.mainScreen.posIcon}>Bag</span>
          </div>
        </button>
      </div>
      <div
        style={{
          width: "100%",
          marginBottom: "0.37rem",
          display: posConfig?.showOrderSalesRep === "Y" ? "block" : "none",
        }}
      >
        <button
          className="cartMenuItems"
          id="sm-parked-bill"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
          onClick={() => {
            setOpenSalesRep({ flag: true, level: "order" });
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
            <img src={user_add} style={{ color: "#fff", height: "2.5vh" }} />
            <span style={styles.screenStyles.mainScreen.posIcon}>Sales Representative</span>
          </div>
        </button>
      </div>
      <div
        style={{
          width: "100%",
          marginBottom: "0.37rem",
          display: posConfig?.showEstimates === "Y" ? "block" : "none",
        }}
      >
        <button
          className="cartMenuItems"
          id="sm-sales-history"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
          onClick={() => {
            setIsEstimatesFlag(true);
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
            <FileTextOutlined style={{ fontSize: "16px" }} />
            <span style={styles.screenStyles.mainScreen.posIcon}>Estimates</span>
          </div>
        </button>
      </div>
    </div>
  );
};

export default IconMenu;
